/**
 * Conversation Search Hook
 * React Query hook for searching across all conversation types
 */

import { useQuery } from "@tanstack/react-query"
import { searchConversations } from "../services/unified-chat.service"

export function useConversationSearch(query: string, page = 1, limit = 20) {
  return useQuery({
    queryKey: ["conversation-search", query, page, limit],
    queryFn: () => searchConversations(query, page, limit),
    enabled: query.length >= 2,
    staleTime: 10 * 1000,
  })
}
